import { Outlet } from "react-router";

const AppointmentCartItemMappingIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AppointmentCartItemMappingIndexPage;
